import React, { forwardRef } from "react";
import { NumberFormatValues, NumericFormat } from "react-number-format";
import MxInputField, { MxInputFieldProps } from "./MxInputField";

export interface MxInputNumberFieldProps extends MxInputFieldProps {
  onChange: (event: {
    target: {
      name: string;
      value: string;
      id: string;
    };
  }) => void;
}
const MxInputNumberField = (props: MxInputNumberFieldProps, ref: any) => {
  const { onChange, ...rest } = props;
  const handleChange = (values: NumberFormatValues) => {
    if (onChange) {
      onChange({
        target: {
          id: props.id ?? "",
          name: props.name ?? "",
          value: values.value
        }
      });
    }
  };
  return (
    <NumericFormat
      {...(rest as any)}
      ref={ref}
      customInput={MxInputField}
      allowLeadingZeros
      onValueChange={handleChange}
      className="MxInputNumberField"
      onBlur={props.onBlur}
      label={props.label}
      inputRef={props.inputRef}
      error={props.error}
      value={props.value}
      data-testid={`${props.id}-input-number-field`}
    />
  );
};

export default forwardRef(MxInputNumberField);
